import { render, staticRenderFns } from "./signUpForm.vue?vue&type=template&id=7c2bfef9&scoped=true&"
import script from "./signUpForm.vue?vue&type=script&lang=js&"
export * from "./signUpForm.vue?vue&type=script&lang=js&"
import style0 from "./signUpForm.vue?vue&type=style&index=0&id=7c2bfef9&prod&lang=less&scoped=true&"
import style1 from "./signUpForm.vue?vue&type=style&index=1&id=7c2bfef9&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2bfef9",
  null
  
)

export default component.exports